import { Api } from "./api"

export class DashboardApi extends Api {
  constructor() {
    super('home', [])
  }
}
